module.exports = __webpack_public_path__ + "img/pic_chanpinjieshao@2x.c839f1fa.png";